import { useCallback, useMemo } from 'react'
import ReactSelect from 'react-select'
import buildStyles from '~/components/react_single_select/styles'

function mapSelectedOptions(options, selected) {
  if (selected) {
    return options.find((option) => option.value === selected)
  } else {
    return options.find((option) => option.default) || null
  }
}

export default function ReactSingleSelect({ id, name, options, selected, onChange, classNamePrefix, isLoading, size }) {
  // react-select expects value to have the same format as options (with "label" and "value" keys)
  // so here we map the selected value back to the respective option
  // this is necessary to simplify the use of the "onChange" hook
  const value = useMemo(() => mapSelectedOptions(options, selected), [options, selected])

  // biome-ignore lint/correctness/useExhaustiveDependencies: todo: re-evaluate dependencies
  const handleOnChange = useCallback(
    (newValue) => {
      onChange(name, newValue.value)
    },
    [name],
  )

  return (
    <ReactSelect
      classNamePrefix={classNamePrefix}
      inputId={id}
      isSearchable
      options={options}
      value={value}
      onChange={handleOnChange}
      styles={buildStyles(size)}
      isLoading={isLoading}
    />
  )
}
